module.exports = __webpack_public_path__ + "img/05.f941b4f8.png";